export default __webpack_public_path__ + "static/media/2d5121e35c96e25d.653f3b192e75145e655f013412827477.svg";